const req_Status = Object.freeze({
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed",
  NULL: null,
});

export { req_Status };
